import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UrlPrefix } from "../common/constants/url-prefix.constants";
import { SystemDictionaries } from '../common/models/SystemDictionaries';

@Injectable()
export class CpqTranslationsService {
    constructor(private http: HttpClient) { }

    public getSystemDictionaries(): Observable<SystemDictionaries>{
        return this.http.get<SystemDictionaries>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/tenant/systemDictionaries`)
    }
}